module.exports = __webpack_public_path__ + "static/media/logo.312ce99d.jpg";